module.exports = __webpack_public_path__ + "images/b10d003fabb10bcac38e42af42f6b360-IMG_8131.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slides/kitchen/IMG_8131.jpg
// module id = ./src/assets/images/slides/kitchen/IMG_8131.jpg
// module chunks = 0